import React from 'react';
import { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import sweetalert2 from 'sweetalert2';
import { useDispatch } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';
import * as Yup from "yup"
import { FileText, Send, Download, TrendingUp, Pencil ,Eye, EyeOff } from "lucide-react";

import {
  prepareContractApi,
} from '../../Service/FeeProtector/FeeProtectorService';
import { getAllClient, getClientDetails } from "../../Service/ThardPartyApi/ThardPartyAPI";
import { downloadContract } from "../../ReduxStore/Slice/Contract/contractSlice";
import { getAllFeeProtector } from '../../Service/FeeProtector/FeeProtectorService';
import { contractRowUpdate } from '../../Service/Contract/contractService';
import debounce from 'lodash.debounce';
import Swal from "sweetalert2";
import { DateConvert, DateConvertWithTime ,cleanHtmlEntities, roundNumber } from "../../Utils/CommonFun";
import axios from "axios";
import Datatable from '../../ExtraComponents/ReusableTable2';
import ReactPaginate from "react-paginate";
import * as Config from "../../Utils/Config";

const ViewFeeProtector = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const agent_id = JSON.parse(localStorage.getItem("agent_id"));
  const user_id = JSON.parse(localStorage.getItem("details"))?.id;

  ///////////////////--- Get Compelete Record -------/////////////////


  const [pageSize, setPageSize] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [InputValue, setInputValue] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [clientDetails, setClientDetails] = useState({});
  const [showLiveContracts, setShowLiveContracts] = useState(false);

   const [showReasonModal, setShowReasonModal] = useState(false);
    const [selectedReason, setSelectedReason] = useState("");

  const clientDataRef = useRef(null);


  const handlePageChange = (page) => {
    setCurrentPage(page.selected + 1);
  };

  const handlePageSizeChange = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setPageSize(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
    setCurrentPage(1);
  }, [InputValue])



  const [feeProtectorData, setFeeProtectorData] = useState([]);

  const debounceSearch = useCallback(
    debounce((value) => setDebouncedSearch(value), 500), []
  );

  const handleInputChange = (e) => {
    setInputValue(e.target.value);
    debounceSearch(e.target.value);
  };

  useEffect(() => { setCurrentPage(1); }, [InputValue]);

  const fetchData = async () => {
    try {
      setLoading(true);
      const res = await getAllFeeProtector({
        agent_id,
        user_id,
        page: currentPage,
        limit: pageSize,
        search: debouncedSearch,
        status: 'client_completed',
        client_id: row?.client_id,
         contract_id: row?.id
      });
      setFeeProtectorData(res?.data ?? []);

       setLoading(false);
       return

      console.log("clientDataRef.current", clientDataRef.current)

      if (res?.data?.length > 0 && clientDataRef.current == null) {
        clientDataRef.current = 1
      }
      // setTotalRecords(res?.pagination?.total);
      //setTotalRecords(res?.pagination?.totalPages);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };



  useEffect(() => { fetchData(); }, [currentPage, pageSize, debouncedSearch]);


  // Reason field state
  const [editRowId, setEditRowId] = useState(null);
  const [currentRowId, setCurrentRowId] = useState(null);
  const [reasonText, setReasonText] = useState("");
  const [showSaved, setShowSaved] = useState(false);

  const handleEditReason = (row) => {
    setEditRowId(row.id);
    setCurrentRowId(row.id);
    setReasonText(row.reason_text || "");
  };

  const handleSaveReason = async (row) => {
    try {

      const response = await contractRowUpdate({
        id: row.id,
        reason_text: reasonText,
      });

      if (response?.status == true) {
        setEditRowId(null);
        setShowSaved(true);
        setTimeout(() => {
          setShowSaved(false);
        }, 2000);

        fetchData(); // reload table
      } else {
        sweetalert2.fire({
          icon: "error",
          title: "Error",
          text: response?.message,
          background: "#fff",
          backdrop: "rgba(229, 233, 236, 0.2)",
          customClass: {
            popup: "",
          },
        })
      }
    } catch (error) {
      sweetalert2.fire({
        icon: "error",
        title: "Error",
        text: error?.message,
        background: "#fff",
        backdrop: "rgba(229, 233, 236, 0.2)",
        customClass: {
          popup: "",
        },
      })
    }
  };


  const columns = useMemo(() => [
    {
      name: "Subject",
      selector: (row) => row?.subject == null || row?.subject == "" ? "-" : row?.subject,
      sortable: true,
    },
    {
      name: "Client",
      selector: (row) => cleanHtmlEntities(row?.Client?.client_name),
      sortable: true,
    },

    {
      name: "Created On",
      //selector: (row) => DateConvertWithTime(row?.createdAt),
      selector: (row) => (
        <span className='create-at-tble'>
          {DateConvertWithTime(row?.createdAt)}
        </span>
      ),
      sortable: true,
    },

    // {
    //   name: "Reason",
    //   cell: (row) => {

    //     // Renewal Record
    //     if (row?.is_renewal === true) {
    //       return (
            // <div
            //   className="reason-edit-container"
            //   title="Click to edit reason"
            // >
            //   <textarea
            //     className="reason-textarea"
            //     value={row?.reason_text || ""}
            //     readOnly
            //     rows={5}
            //     disabled
            //   />
            // </div>
    //       );
    //     }

    //    // Contract Record
    //     const isEditing = editRowId === row.id;
    //     if (isEditing) {
    //       return (
    //         <div className="reason-edit-container">
    //           <textarea
    //             className="reason-textarea"
    //             defaultValue={reasonText}
    //             //onChange={(e) => setReasonText(e.target.value)}
    //             onChange={(e) => {
    //               const cursorPos = e.target.selectionStart;
    //               setReasonText(e.target.value);

    //               requestAnimationFrame(() => {
    //                 e.target.selectionStart = cursorPos;
    //                 e.target.selectionEnd = cursorPos;
    //               });
    //             }}
    //             rows={5}
    //           />

    //           <button
    //             className="reason-save-btn"
    //             onClick={() => handleSaveReason(row)}
    //           >
    //             <i className="ri-save-line me-1"></i>
    //             Save
    //           </button>
    //         </div>
    //       );
    //     }
    //     return (
    //       <div
    //         className="reason-edit-container"
    //         title="Click to edit reason"
    //       >
    //         <textarea
    //           className="reason-textarea"
    //           value={row?.reason_text || ""}
    //           readOnly
    //           rows={5}
    //         />

    //         {showSaved && currentRowId === row.id && (
    //           <span className="reason-saved">
    //             Saved
    //           </span>
    //         )}

    //         <i
    //           className="ri-pencil-line reason-edit-icon"
    //           onClick={() => handleEditReason(row)}
    //         />
    //       </div>
    //     );
    //   },
    //   grow: 2,
    // },
    {
      name: "Status",
      selector: (row) => {
        const contractSigned = Number(row?.contract_signed);
        const status = Number(row?.status);
        const step = Number(row?.step);

        if (contractSigned === 1) {
          if(row?.is_renewal){
          return "Contract Renewed"
          }
          return "Contract Signed";
        }

        if (status === 4) {
          return "Contract Declined";
        }

        if (status === 3) {
          return "Contract Reviewed";
        }

        if (step === 4) {
          return "Contract Sent";
        }

        return "-";
      },
      sortable: true,
    },
    {
      name: "Reason",
      selector: (row) => row?.reason_text || "-",
      sortable: true,
        cell: (row) => (
      <div className="reason-show-container">
      <p className="reason-show">
        {row?.reason_text || "-"}
      </p>
      {
        ["",undefined,null].includes(row?.reason_text) ? ""
        :
         <span className="reason-show-custom-tooltip">{row?.reason_text}</span>
      }
     
      </div>
    ),
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          {/* preview button */}

           {
            row?.is_renewal == true ? (
              <button
                className="btn fs-4 py-0 px-1 border-0"
                onClick={() => handlePreview(row)}
              //  onClick={(e) => {
              //   e.stopPropagation(); //
              //   setSelectedReason(row?.reason_text || "No reason available.");
              //   setShowReasonModal(true);
              // }}
                title="Preview Contract"
              >
                <i className="ri-eye-line"></i>
              </button>
            )
            :
            (

              <button
                className="btn fs-4 py-0 px-1 border-0"
                onClick={() => handlePreview(row)}
                title="Preview Contract"
              >
                <i className="ri-eye-line"></i>
              </button>

            )
           }

          




          {/* Download/Convert Button */}
          <button
            className="btn fs-4 py-0 px-1 border-0"
            onClick={() => handleConvert(row)}
            title="Download Document"
          >
            <i className="ri-download-2-line" />
          </button>

        </div>
      ),
      sortable: true,
    },
  ], [
    editRowId,
    reasonText,
    currentRowId,
    showSaved
  ]);


  const handleConvert = async (row) => {

    if (!row?.pendingId || !row?.orignalId || !row?.access_token) {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Please complete the contract first",

        background: "#fff",
        backdrop: "rgba(229, 233, 236, 0.2)",
        customClass: {
          popup: "",
        },
      });
      return;
    }

    let req = { agent_id: agent_id, id: row?.id };
    await dispatch(downloadContract(req))
      .unwrap()
      .then((response) => {
        if (response.status) {
          // console.log("response.data-->>",response)
          let access_token = response.data

          // let access_token = "eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCIsImtpZCI6IjdMLXZ0VDNiN2pYc2I2cUZjLVBhNyJ9.eyJodHRwczovL3NpZ25lYXN5LmNvbS9lbWFpbCI6ImVzaWduQG5vbWlzbWFzb2x1dGlvbi5jby51ayIsImh0dHBzOi8vc2lnbmVhc3kuY29tL3VzZXJfaWQiOiI1MjUxNDc2IiwiaHR0cHM6Ly9zaWduZWFzeS5jb20vdGVzdF9tb2RlIjoiMSIsImlzcyI6Imh0dHBzOi8vYXV0aC5zaWduZWFzeS5jb20vIiwic3ViIjoidHdhZHRTZTN1ckU5cWZETUVlU0N0eHFudnk1dklzNHhAY2xpZW50cyIsImF1ZCI6Imh0dHBzOi8vYXBpLWV4dC5zaWduZWFzeS5jb20vIiwiaWF0IjoxNzY1ODAyMTM4LCJleHAiOjE3NjgzOTQxMzgsInNjb3BlIjoidXNlcjpyZWFkIGZpbGVzOnJlYWQgb3JpZ2luYWw6cmVhZCBvcmlnaW5hbDpjcmVhdGUgb3JpZ2luYWw6dXBkYXRlIHNpZ25lZDpyZWFkIHNpZ25lZDpjcmVhdGUgc2lnbmVkOnVwZGF0ZSByczpyZWFkIHJzOmNyZWF0ZSByczp1cGRhdGUgcnM6c2lnbmluZ3VybCB0ZW1wbGF0ZTptYW5hZ2Ugd2ViaG9va3M6bWFuYWdlIiwiZ3R5IjoiY2xpZW50LWNyZWRlbnRpYWxzIiwiYXpwIjoidHdhZHRTZTN1ckU5cWZETUVlU0N0eHFudnk1dklzNHgifQ.RfQwxVSP-TV6zMN6Uo1NmhFvZOIg1dgAL3Cp0bV_1GKG9LxWT7bxGH6hirTlMfboOuIT-_vZ4qDt3LgdpF6B9RazaV-enFqEkV_EBdh5iTe26_t12vRWaI04X6AOnpIYd5D-I136tkUhw3-7cziIqxH48ATFtvL_ti8BTknPnhSkRYxJzaPN2wQYat2w4Bnfp7zFDIIBtEm5ixFlTfzoOEsU-UtIRif0yACej_KT9rrQcvhWJfq5QrLzkySCkks4Lao88_7_SO64XCRPkqjJLfmD3sJciN74qzwW9zsoS_RKXtgNaueNIKfu2p_t3tHmrwubCgEmpCsjd11EEkIi1A"

          setLoading(true);
          let config = {
            method: "get",
            maxBodyLength: Infinity,
            url: `https://api.signeasy.com/v3/rs/envelope/signed/${row.pendingId}/${row.orignalId}/download`,
            headers: {
              //Authorization: "Bearer " + row?.access_token,
              Authorization: "Bearer " + access_token,
            },
            responseType: "blob", // Important for binary PDF
          };

          axios
            .request(config)
            .then((response) => {
              setLoading(false);
              const blob = new Blob([response.data], { type: "application/pdf" });
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = `${row.subject || "document"}.pdf`;
              document.body.appendChild(a);
              a.click();
              a.remove();
              window.URL.revokeObjectURL(url);
            })
            .catch((error) => {
              setLoading(false);

              console.log("Download error:", error);
            });


        } else {

        }
      })
      .catch((error) => {
        console.error("Error fetching charge basis data:", error);
      });
  };





  ///////////////////// ----------------////////////////////////////

  const [showPdfModal, setShowPdfModal] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);


  const [previewModal, setPreviewModal] = useState(false);
  const handlePreview = async (row) => {
    try {
      if (!row?.pendingId || !row?.orignalId) {
        Swal.fire({
          icon: "warning",
          title: "Oops...",
          text: "Please complete the contract first",
        });
        return;
      }

      let req = {
        agent_id: agent_id,
        id: row?.id,
      };

      const response = await dispatch(downloadContract(req)).unwrap();

      if (response.status) {
        const access_token = response.data;

        setLoading(true);

        const pdfResponse = await axios.get(
          `https://api.signeasy.com/v3/rs/envelope/signed/${row.pendingId}/${row.orignalId}/download`,
          {
            headers: {
              Authorization: `Bearer ${access_token}`,
            },
            responseType: "blob",
          }
        );

        const blob = new Blob([pdfResponse.data], {
          type: "application/pdf",
        });

        const url = URL.createObjectURL(blob);

        setPdfUrl(url);
        setShowPdfModal(true);

        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };



  //const row = location?.state;
  const [row, setRow] = useState(location?.state);

  const fetchDataSingleClient = async () => {
    try {
      setLoading(true);

      const res = await getAllFeeProtector({
        agent_id,
        user_id,
        page: currentPage,
        limit: pageSize,
        search: debouncedSearch,
        status: "single_client",
        client_id: row?.client_id,
      });

      if (res?.data?.length > 0) {
        setRow(res.data[0]);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const turnoverData = row?.finalDriverData?.find((item) =>
    item?.ChargeBasis?.pricing_queries
      ?.toLowerCase()
      ?.includes("turnover")
  );

  const finalDriverData = row?.finalDriverData?.map((item) => {
    const queryName =
      item?.ChargeBasis?.pricing_queries?.toLowerCase() || "";

    if (queryName.includes("without pension")) {
      const frequencyValue =
        row?.ContractEnterDefaultValues?.find(
          (item2) => item2?.chargebasis_id === item?.chargebasis_id
        )?.frequencyValue || 1;

      const oldValue = Number(Number(item.inputValue) * Number(frequencyValue)) || 0;
      const currentValue = Number(item?.currentValue) || 0;
      const change = currentValue - oldValue;
      // if (change <= 0) return null;

      const percentage = oldValue ? (change / oldValue) * 100 : 0;
      // if (parseFloat(percentage) <= 10) return null;

      return {
        ...item,
        inputValue: oldValue,
        change: change,
        percentage: Number(percentage.toFixed(3)),
      };
    }

    return item;
  });






  useEffect(() => {
    //fetchDataSingleClient();
    if (!['', null, undefined].includes(row?.Client?.am_name)) {
      return;
    }
    const fetchClientDetails = async () => {
      try {

        setLoading(true);

        const company_id = JSON.parse(localStorage.getItem("company_id"));
        const agent_db = localStorage.getItem("agent_db");
        const token_crm = localStorage.getItem("authClientToken");
        const agent_url = localStorage.getItem("agent_url");

        const req = {
          agent_db,
          company_id,
          pricing_tool_pratice_id: agent_id,
          module: row?.Client?.module_type,
          record_id: row?.record_id || 0,
        };

        const res = await getClientDetails(req, agent_url, token_crm);
        console.log("res", res);
        if (res.IsSuccess) {

          setClientDetails(res?.result);
        } else {
          setClientDetails({});
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchClientDetails();
  }, []);






  // console.log("turnoverData - ", turnoverData)
  
  // const current_fee_yearly = parseFloat(row?.total_monthly_excluding_ongoing) * parseFloat(row?.frequencyCodeNumber_ongoing)
  // const at_Contract_date = (current_fee_yearly / turnoverData?.inputValue) * 100
  // const at_Current = (current_fee_yearly / turnoverData?.currentValue) * 100


  const at_Contract_date = (row?.total_monthly_excluding_ongoing / turnoverData?.inputValue) * 100
  const at_Current = (row?.total_monthly_excluding_ongoing_new / turnoverData?.currentValue) * 100
  const vat = row?.Client?.FeeProtectorDriverValues?.[0]?.vatregistered
  // At Contract Date

  const formatNumber = (num) => {
    if (num === null || num === undefined) return null;
    return new Intl.NumberFormat("en-GB").format(Number(num));
  };

  const handlePrepareContract = async () => {

    if (['', null, undefined].includes(row?.contractTypeOngoing)) {

      sweetalert2.fire({
        title: "Prepare Contract",
        text: "Are you sure you want to prepare this contract?",
        showCancelButton: true,
        confirmButtonText: "Yes, Prepare",
        cancelButtonText: "No, Cancel",
        customClass: {
          popup: 'my-swal-height',
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const data = {
              agent_id: agent_id,
              user_id: user_id,
              contract: row,
              type: "prepare"
            };
            setLoading(true);
            const res = await prepareContractApi(data);
            if (res?.status === true) {
              // console.log("res", res?.contract);
              setLoading(false);
              sessionStorage.setItem("contract_id", res?.contract?.id);
              navigate("/admin/contracts/create-contract", { state: { row: res?.contract } });
            } else {
              setLoading(false);
              sweetalert2.fire({
                icon: "error",
                title: "Error",
                text: res?.message
              })
            }


          } catch (error) {
            setLoading(false);
            console.log(error);
          }
        }
      })

    } else {

      sweetalert2.fire({
        title: "Prepare Contract",
        text: "Please verify that the selected Contract Type and Payment Type are correct.",
        showCancelButton: true,
        confirmButtonText: "Next",
        cancelButtonText: "Back",
        customClass: {
          popup: 'my-swal-height',
        }
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const data = {
              agent_id: agent_id,
              user_id: user_id,
              contract: row,
              type: "prepare"
            };
            setLoading(true);
            const res = await prepareContractApi(data);
            if (res?.status === true) {
              // console.log("res", res?.contract);
              setLoading(false);
              sessionStorage.setItem("contract_id", res?.contract?.id);
              navigate("/admin/contracts/create-contract", { state: { row: res?.contract } });
            } else {
              setLoading(false);
              sweetalert2.fire({
                icon: "error",
                title: "Error",
                text: res?.message
              })
            }


          } catch (error) {
            setLoading(false);
            console.log(error);
          }
        }
      })


    }

  }

  const handleSendContract = async () => {
    sweetalert2.fire({
      title: "Send Contract",
      text: "Are you sure you want to send this contract?",
      showCancelButton: true,
      confirmButtonText: "Yes, Send",
      cancelButtonText: "No, Cancel",
      customClass: {
        popup: 'my-swal-height',
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const data = {
            agent_id: agent_id,
            user_id: user_id,
            contract: row,
            type: "send"
          };
          setLoading(true);
          const res = await prepareContractApi(data);
          if (res?.status === true) {
            // console.log("res", res?.contract);
            setLoading(false);
            sessionStorage.setItem("contract_id", res?.contract?.id);
            navigate("/admin/contracts/create-contract", { state: { row: res?.contract } });
          } else {
            setLoading(false);
            sweetalert2.fire({
              icon: "error",
              title: "Error",
              text: res?.message
            })
          }

        } catch (error) {
          setLoading(false);
          console.log(error);
        }
      }
    })
  }

  const handleNoActionContract1 = async () => {
    sweetalert2.fire({
      title: "No Action Required",
      text: "Are you sure you want to mark this contract as 'No Action Required'?",
      showCancelButton: true,
      confirmButtonText: "Yes, Send",
      cancelButtonText: "No, Cancel",
      customClass: {
        popup: 'my-swal-height',
      }
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const data = {
            agent_id: agent_id,
            user_id: user_id,
            contract: row,
            type: "no_action",
            reason_text: "All Okay No Action Required"
          };
          setLoading(true);
          const res = await prepareContractApi(data);
          if (res?.status === true) {
            console.log("res", res);
            fetchData()
            setLoading(false);

           // sessionStorage.setItem("contract_id", res?.contract?.id);
           // navigate("/admin/contracts/create-contract", { state: { row: res?.contract } });
          } else {
            setLoading(false);
            sweetalert2.fire({
              icon: "error",
              title: "Error",
              text: res?.message
            })
          }

        } catch (error) {
          setLoading(false);
          console.log(error);
        }
      }
    })
  }

  const handleNoActionContract = async () => {
  // Step 1 - Reason Input
  const reasonResult = await sweetalert2.fire({
    title: "Enter Reason",
    input: "textarea",
    //inputLabel: "Reason",
    inputPlaceholder: "Write reason here...",
    showCancelButton: true,
    confirmButtonText: "Submit",
    cancelButtonText: "Cancel",
    inputValidator: (value) => {
      if (!value || value.trim() === "") {
        return "Please enter a reason!";
      }
    },
  });

  if (!reasonResult.isConfirmed) {
    return;
  }

  const reasonText = reasonResult.value;

  // Step 2 - Confirmation
  // const result = await sweetalert2.fire({
  //  title: "No Action Required",
  //     text: "Are you sure you want to mark this contract as 'No Action Required'?",
  //     showCancelButton: true,
  //     confirmButtonText: "Yes, Send",
  //     cancelButtonText: "No, Cancel",
  //     customClass: {
  //       popup: 'my-swal-height',
  //     }
  // });

   

  // if (!result.isConfirmed) {
  //   return;
  // }

  try {
    setLoading(true);

    const data = {
      agent_id: agent_id,
      user_id: user_id,
      contract: row,
      type: "no_action",
      client_id: row?.client_id,
      reason_text: reasonText, // textarea ka data
    };
    //console.log("data ->",data)
    // alert("ok")
    // setLoading(false);
    // return

    const res = await prepareContractApi(data);

    if (res?.status === true) {
      
      sweetalert2.fire({
        icon: "success",
        title: "Success",
        text: "Contract Renewal Completed Successfully.",
        confirmButtonText: "OK",
      }).then((result) => {
        if (result.isConfirmed) {
          navigate("/admin/feeprotector"); //
          //fetchData();
        }
      });
      
    } else {
      setLoading(false);

      sweetalert2.fire({
        icon: "error",
        title: "Error",
        text: res?.message,
      });
    }
  } catch (error) {
    setLoading(false);
    console.log(error);

    sweetalert2.fire({
      icon: "error",
      title: "Error",
      text: "Something went wrong.",
    });
  }
};

  const handleExportPdf = async () => {

    if (['', null, undefined].includes(row?.contractTypeOngoing)) {
      sweetalert2.fire({
        icon: "warning",
        title: "Contract Type Missing",
        text: "PDF export is not available for this contract.",
        background: "#fff",
        backdrop: "rgba(229, 233, 236, 0.2)",
        customClass: {
          popup: "",
        },
      });
      return;
    }

    sweetalert2.fire({
      title: "Export PDF",
      text: "Are you sure you want to export this PDF?",
      showCancelButton: true,
      confirmButtonText: "Yes, Export",
      cancelButtonText: "No, Cancel",
      customClass: {
        popup: 'my-swal-height',
      }
    }).then(async (result) => {
      if (result.isConfirmed) {

        try {
          const data = {
            agent_id: agent_id,
            user_id: user_id,
            contract: row,
            type: "pdf"
          };
          setLoading(true);
          const res = await prepareContractApi(data);
          if (res?.status === true) {
            // console.log("res", res?.contract);
            setLoading(false);
            if (res.status) {
              const base64String = res.data;
              const byteCharacters = atob(base64String);
              const byteNumbers = new Array(byteCharacters.length);

              for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
              }

              const byteArray = new Uint8Array(byteNumbers);
              const blob = new Blob([byteArray], { type: "application/pdf" });
              const blobUrl = URL.createObjectURL(blob);

              setPdfUrl(blobUrl);
              setShowPdfModal(true);
              setLoading(false);
            } else {
              setLoading(false);
              sweetalert2.fire({
                icon: "error",
                title: "Error",
                text: res.msg,
                timer: 9000,
                timerProgressBar: true,
              });
            }
          } else {
            setLoading(false);
            sweetalert2.fire({
              icon: "error",
              title: "Error",
              text: res?.message
            })
          }

        } catch (error) {
          setLoading(false);
          console.log(error);
        }

      }
    })
  }

  const handleExport = async () => {
    /////////
    setLoading(true);

    try {
      const exportData = [
        {
          "CLIENT": row?.Client?.client_name || "-",
          "CLIENT MANAGER": row?.Client?.am_name || "-", 
          "STATUS": row?.statusFeeProtector || "-",
         "CURRENT FEE":roundNumber(Number(row?.total_monthly_excluding_ongoing || 0)),
        "CURRENT FEE FREQUENCY": row?.frequencyCode_ongoing || "-",
        "PROPOSED FEE": row?.finalDriverData?.length === 0
          ? "-"
          : roundNumber(Number(row?.total_monthly_excluding_ongoing_new || 0)),
        "PROPOSED FEE FREQUENCY": row?.frequencyCode_ongoing || "-",
        "FEE GAP":
          row?.finalDriverData?.length === 0
            ? "-"
            : roundNumber(
              roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
              roundNumber(row?.total_monthly_excluding_ongoing || 0)
            ),

        "FEE GAP FREQUENCY": row?.frequencyCode_ongoing || "-",
        "FEE GAP PERCENTAGE (%)":row?.finalDriverData?.length === 0 ? "-":row?.percentageIncrease_ongoing || 0,

        "ANNUAL FEE GAP": roundNumber(
              row?.frequencyCodeNumber_ongoing *
              (
                roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
                roundNumber(row?.total_monthly_excluding_ongoing || 0)
              )
          ),
        "ANNUAL FEE GAP FREQUENCY": row?.frequencyCode_ongoing || "-",       
        "ANNUAL FEE GAP PERCENTAGE (%)":row?.finalDriverData?.length === 0 ? "-":row?.percentageIncrease_ongoing || 0,   
        "NEXT REVIEW": row?.nextReview || "-",
        },
      ];
      downloadCSV(exportData, "FeeProtectorDetails.csv");

    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const downloadCSV = (data, filename) => {
    if (!data || !data.length) return;
    const headers = Object.keys(data[0]);
    const csvRows = [];
    // HEADER
    csvRows.push(headers.join(","));
    // BODY
    data.forEach((row) => {
      const values = headers.map((header) => {
        let value = row[header] ?? "";
        // double quotes escape
        value = String(value).replace(/"/g, '""');
        return `"${value}"`;
      });
      csvRows.push(values.join(","));
    });
    const csvString = csvRows.join("\n");
    // UTF-8 BOM ADD
    const csvWithBom = "\uFEFF" + csvString;
    const blob = new Blob(
      [csvWithBom],
      {
        type: "text/csv;charset=utf-8;",
      }
    );
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleExportPDFSingle = async () => {
    setLoading(true);

    const formattedData = [{

      "Client": row?.Client?.client_name || "-",
      "Client Manager": row?.Client?.am_name || "-", 
      "Status": row?.statusFeeProtector || "-",
      "Current Fee":roundNumber(Number(row?.total_monthly_excluding_ongoing || 0)),
      "Proposed Fee": row?.finalDriverData?.length === 0
        ? "-"
        : roundNumber(Number(row?.total_monthly_excluding_ongoing_new || 0)),
      "Fee Gap":
        row?.finalDriverData?.length === 0
          ? "-"
          : roundNumber(
            roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
            roundNumber(row?.total_monthly_excluding_ongoing || 0)
          ),

      "Annual Fee Gap": roundNumber(
            row?.frequencyCodeNumber_ongoing *
            (
              roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
              roundNumber(row?.total_monthly_excluding_ongoing || 0)
            )
        ),
      "Frequency": row?.frequencyCode_ongoing || "-",   
      "Percentage (%)":row?.finalDriverData?.length === 0 ? "-":row?.percentageIncrease_ongoing || 0,   
      "Next Review": row?.nextReview || "-",
    }];



    const res = await axios.post(
      Config.base_url + "export-contract-pdf",
      { data: formattedData, type: "feeProtector" },
      { responseType: "blob" }
    );

    setLoading(false);

    const blob = new Blob([res.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "FeeProtectorDetails.pdf";
    a.click();
  };


  useEffect(() => {
    if (isLoading) {
      sweetalert2.fire({
        title: "",
        html: '<div style="height:250px;"><div class="loader" style="margin:0px auto;"></div><p class="text-white mt-3">Please Wait...</p></div>',
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        background: "transparent",
        backdrop: "rgba(229, 233, 236, 0.2)",

        customClass: {
          popup: "no-shadow",
        },
      });
    } else {
      sweetalert2.close();
    }
  }, [isLoading]);

  return (
    <div className="config-setting-container">

      <section className="section">

        <div className='w100'>
          <div className="back-btn d-flex align-items-center gap-2 mb-3 justify-content-between">
            <div>
              <button
                className="btn btn-outline-secondary btn-icon mb-2"
                onClick={() => navigate("/admin/feeprotector")}
                style={{ cursor: "pointer" }}
              >
                ← Back to Dashboard
              </button>
            </div>

            <div>
              <button className="btn-outline-pink btn me-2" onClick={handleExportPDFSingle}>
                <i className="ri-download-2-line"></i> Export PDF
              </button>

              <button className="btn-outline-pink btn me-2"
                onClick={handleExport}
              >
                <i className="ri-download-2-line"></i>  Export CSV
              </button>
            </div>
          </div>

          {/* HEADER */}
          <header className="barnet-top">
            <div className="client-info">
              <div className="title-row">
                {/* <h1>{row?.Agent?.agent_name}</h1> */}
                <h1>{cleanHtmlEntities(row?.Client?.client_name)}</h1>
                <span className="badge-error">{row?.statusFeeProtector}</span>
              </div>

              <p className="subtitle">
                Client Manager : {clientDetails?.am_name || row?.Client?.am_name}  {vat === "Yes" ? " • VAT Registered • " : vat === "No" ? " • VAT Not Registered • " : " • "} Last Contracted on {row?.lastContractDate}
              </p>
            </div>

            <div className="fee-overview">
              <div className="fee-item">
                <span className="label">CURRENT FEE</span>
                <span className="value">£{roundNumber(row?.total_monthly_excluding_ongoing) + "/" + row?.frequencyCode_ongoing}</span>
              </div>

              <div className="fee-item highlight-purple">
                <span className="label">PROPOSED FEE</span>
                {
                  row?.finalDriverData?.length === 0 ?
                    <span> - </span>
                    :
                    <span className="value">£{roundNumber(row?.total_monthly_excluding_ongoing_new) + "/" + row?.frequencyCode_ongoing}</span>
                }

              </div>

              <div className="fee-item highlight-red">
                <span className="label">{row?.frequencyName_ongoing} GAP</span>
                {
                  row?.finalDriverData?.length === 0 ?
                    <span> - </span>
                    :
                    // <span className="value">+£{formatNumber((parseFloat(row?.total_monthly_excluding_ongoing_new) - parseFloat(row?.total_monthly_excluding_ongoing))?.toFixed(2))}</span>
                    <span className="value">
                      +£
                      {roundNumber(
                          roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
                          roundNumber(row?.total_monthly_excluding_ongoing || 0)
                      )}
                      {" "}
                      {/* (
                      
                         {parseFloat(row?.total_monthly_excluding_ongoing || 0) > 0
                        ? (
                          ((parseFloat(row?.total_monthly_excluding_ongoing_new || 0) -
                            parseFloat(row?.total_monthly_excluding_ongoing || 0)) /
                            parseFloat(row?.total_monthly_excluding_ongoing || 0)) *
                          100
                        ).toFixed(2)
                        : 0}
                      %) */}
                      ({row?.percentageIncrease_ongoing}%)
                    </span>
                }

              </div>

              <div className="fee-item highlight-red">
                <span className="label">ANNUAL GAP</span>
                {
                  row?.finalDriverData?.length === 0 ?
                    <span> - </span>
                    :
                    // <span className="value">+£{formatNumber((row?.frequencyCodeNumber_ongoing * (parseFloat(row?.total_monthly_excluding_ongoing_new) - parseFloat(row?.total_monthly_excluding_ongoing)))?.toFixed(2))}</span>
                    // <span className="value">
                    //   +£
                    //   {formatNumber(
                    //     (
                    //       row?.frequencyCodeNumber_ongoing *
                    //       (
                    //         parseFloat(row?.total_monthly_excluding_ongoing_new || 0) -
                    //         parseFloat(row?.total_monthly_excluding_ongoing || 0)
                    //       )
                    //     ).toFixed(2)
                    //   )}
                    //   {" "}
                    //   (
                    //   {parseFloat(row?.total_monthly_excluding_ongoing || 0) > 0
                    //     ? (
                    //       row?.frequencyCodeNumber_ongoing *
                    //       ((
                    //         (
                    //           parseFloat(row?.total_monthly_excluding_ongoing_new || 0) -
                    //           parseFloat(row?.total_monthly_excluding_ongoing || 0)
                    //         ) /
                    //         parseFloat(row?.total_monthly_excluding_ongoing || 0)
                    //       ) *
                    //         100
                    //       ).toFixed(2)).toFixed(2)
                    //     : "0.00"}
                    //   %)
                    // </span>

                    <span className="value">
                      +£
                      {roundNumber(
                          row?.frequencyCodeNumber_ongoing *
                          (
                            roundNumber(row?.total_monthly_excluding_ongoing_new || 0) -
                            roundNumber(row?.total_monthly_excluding_ongoing || 0)
                          )
                      )}
                      {" "}
                      {/* (
                      {parseFloat(row?.total_monthly_excluding_ongoing || 0) > 0
                        ?
                        ((
                          (
                            parseFloat(row?.total_monthly_excluding_ongoing_new || 0) -
                            parseFloat(row?.total_monthly_excluding_ongoing || 0)
                          ) /
                          parseFloat(row?.total_monthly_excluding_ongoing || 0)
                        ) *
                          100
                        ).toFixed(2)
                        : "0.00"}
                      %) */}
                       ({row?.percentageIncrease_ongoing}%)
                    </span>
                   }
              </div>
            </div>
          </header>

          {/* FEE DRIVERS */}
          <section className="section-title">FEE DRIVERS</section>

          <div className="grid-4-col">
            {finalDriverData &&
              [...finalDriverData]
                ?.sort((a, b) => {
                  const getOrder = (query = "") => {
                    const q = query.toLowerCase();

                    if (q.includes("turnover")) return 1;
                    if (q.includes("transaction")) return 2;
                    if (q.includes("without pension")) return 3;

                    return 4;
                  };

                  return (
                    getOrder(a?.ChargeBasis?.pricing_queries) -
                    getOrder(b?.ChargeBasis?.pricing_queries)
                  );
                })
                ?.map((item, index) => {
                  if (parseFloat(item?.inputValue) === 0) {
                    return null;
                  }

                  const queryName = item?.ChargeBasis?.pricing_queries?.toLowerCase() || "";

                  return (
                    <div className="barnet-card" key={index}>
                      <div className="barnet-card-header">
                        <span
                          className={`icon ${queryName.includes("turnover")
                            ? "turnover"
                            : queryName.includes("transaction")
                              ? "transaction"
                              : queryName.includes("without pension")
                                ? "without pension"
                                : ""
                            }`}
                        >
                          {queryName.includes("turnover")
                            ? "£"
                            : queryName.includes("transaction")
                              ? "▤"
                              : queryName.includes("without pension")
                                ? "👥"
                                : "•"}
                        </span>

                        {item?.ChargeBasis?.pricing_queries}
                      </div>


                      <div className="barnet-card-body">
                        <div className="col">
                          <span className="label">AT CONTRACT DATE</span>
                          <span className="amount">
                            {queryName.includes("turnover")
                              ? `£${roundNumber(item?.inputValue)}`
                              : item?.inputValue}
                          </span>
                        </div>

                        <div className="col text-end">
                          <span className="label">CURRENT</span>
                          <span className="amount">
                            {queryName.includes("turnover")
                              ? `£${roundNumber(item?.currentValue)}`
                              : item?.currentValue}
                          </span>
                        </div>
                      </div>

                      {
                        Number(item?.inputValue) > Number(item?.currentValue) ?
                          <div className="barnet-card-footer negative text-danger">
                            <p className="footer-change-text">Change</p>
                            <p>
                              {queryName.includes("turnover")
                                ? `£${roundNumber(item?.change)} (${item?.percentage}%)`
                                : `${item?.change} (${item?.percentage}%)`}
                            </p>
                          </div>
                          :

                          Number(item?.percentage) > 10 ?

                            <div className="barnet-card-footer positive">
                              <p className="footer-change-text">Change</p>
                              <p>
                                {queryName.includes("turnover")
                                  ? `+£${roundNumber(item?.change)} (+${item?.percentage}%)`
                                  : `+${item?.change} (+${item?.percentage}%)`}
                              </p>
                            </div>
                            :

                            <div className="barnet-card-footer"
                              style={{ color: "orange" }}
                            >
                              <p className="footer-change-text">Change</p>
                              <p>
                                {queryName.includes("turnover")
                                  ? `+£${roundNumber(item?.change)} (+${item?.percentage}%)`
                                  : `+${item?.change} (+${item?.percentage}%)`}
                              </p>
                            </div>


                      }

                      {/* <div className="barnet-card-footer positive">
                        <p className="footer-change-text">Change</p>
                        <p>
                          {queryName.includes("turnover")
                            ? `+£${formatNumber(item?.change)} (+${item?.percentage}%)`
                            : `+${item?.change} (+${item?.percentage}%)`}
                        </p>
                      </div> */}
                    </div>
                  );
                })}
          </div>

          {/* RATIO */}
          {/* {
            !['', null, undefined].includes(turnoverData) ?
              <div className="ratio-card">
                <span className="label">FEE / TURNOVER RATIO</span>

                <div className="ratio-flex">
                  <div className="ratio-item">
                    <span className="label">At Contract Date</span>
                    <div className="value-large">{at_Contract_date?.toFixed(2)}%</div>
                  </div>

                  <div className="ratio-item">
                    <span className="label">Current</span>
                    <div className="value-large color-red">{at_Current?.toFixed(2)}%</div>
                    
                  </div>
                </div>
              </div>
              :
              ""
          } */}



          {/* ACTIONS */}
          <div className="actions">


            <button
          className="btn btn-outline-secondary btn-icon fee-btn-text-color2 "
          onClick={() => setShowLiveContracts(!showLiveContracts)}
        >
           {showLiveContracts ? (
            <EyeOff size={18} className="me-2" />
          ) : (
            <Eye size={18} className="me-2" />
          )}
          {showLiveContracts
            ? "Hide Current Live Contracts"
            : "Show Current Live Contracts"}
        </button>



            <div className="btn btn-outline-secondary btn-icon fee-btn-text-color2 "
              onClick={
                () => handlePrepareContract()
              }
            >
              <FileText size={18} />
              <span >Prepare New Contract</span>
            </div>

            {/* <button
              className="btn btn-outline-secondary btn-icon fee-btn-text-color2 "
              onClick={
                () => handleSendContract()
              }
            >
              <Send size={18} /> Send Contract
            </button> */}


            <button
              className="btn btn-outline-secondary btn-icon fee-btn-text-color2 "
              onClick={
                () => handleNoActionContract()
              }
            >
              <Send size={18} /> No Action Required
            </button>

            <button
              className="btn btn-outline-secondary btn-icon fee-btn-text-color2 "
              onClick={
                () => handleExportPdf()
              }

            >
              <Download size={18}
              /> Export PDF
            </button>



          </div>

          {/* HISTORY */}
          {/* <div className="ratio-card">
            <div className="history-heading">COMPARISON HISTORY</div>

            <div className="history-item">
              <span className="time-icon">🕒</span>

              <span className="history-text">
                15 Jan 2024 — Comparison run by {row?.Client?.client_name}. Contract prepared at
                £{(row?.total_monthly_excluding_ongoing)?.toFixed(2) + "/" + row?.frequencyCode_ongoing}.
              </span>
            </div>
          </div> */}

        </div>




        {/* List Compelete Contract*/}


        {/* {
          clientDataRef.current === 1 && (
            <div className="search-box">
              <input
                type="text"
                value={InputValue}
                onChange={handleInputChange}
                placeholder="Search clients..."
              />
            </div>
          )
        } */}

         
        

         {
           showLiveContracts && (
            <h4 className="page-title mt-4 mb-3">
              Current Live Contracts
            </h4>
           )
         } 
        

        {
           showLiveContracts && feeProtectorData && feeProtectorData?.length > 0 ?
            <>


              <div className="quote-table">
                <Datatable
                  columns={columns}
                  data={feeProtectorData}
                  filter={false}
                  onRowClicked={(row) => navigate("/admin/ViewFeeProtector", { state: row })}
                />

                {/* {feeProtectorData?.length > 0 && (
                  <div>
                    <ReactPaginate
                      previousLabel={"Previous"}
                      nextLabel={"Next"}
                      breakLabel={"..."}
                      pageCount={pageSize == 0 ? 1 : Math.ceil(totalRecords / pageSize)}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination"}
                      activeClassName={"active"}
                    />

                    <div className="mt-0">
                      <select
                        className="perpage-select"
                        value={pageSize}
                        onChange={handlePageSizeChange}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={500}>500</option>
                        <option value={0}>ALL</option>
                      </select>
                    </div>
                  </div>
                )} */}
              </div>
            </>
            :
            ""
        }






      </section>

      {showPdfModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-xl" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">PDF Preview</h5>

                {/* Open in New Tab Button */}
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-pink ms-2 btn-sm"
                  style={{ fontSize: '10px' }}
                >
                  Open in New Tab
                </a>

                {/* Close Button */}
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowPdfModal(false)}
                ></button>
              </div>

              <div className="modal-body">
                <iframe
                  src={pdfUrl}
                  title="PDF Preview"
                  width="100%"
                  height="600px"
                  style={{ border: "none" }}
                />
              </div>
            </div>
          </div>
        </div>

      )}

      {showReasonModal && (
  <div
    className="modal fade show d-block"
    tabIndex="-1"
    style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
  >
    <div className="modal-dialog modal-lg modal-dialog-centered">
      <div className="modal-content">

        <div className="modal-header">
          <h5 className="modal-title">Reason</h5>

          <button
            type="button"
            className="btn-close"
            onClick={() => setShowReasonModal(false)}
          />
        </div>

        <div className="modal-body">
          <pre
            style={{
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              background: "#f8f9fa",
              border: "1px solid #dee2e6",
              borderRadius: "6px",
              padding: "15px",
              maxHeight: "450px",
              overflowY: "auto",
              fontSize: "14px",
              margin: 0,
            }}
          >
            {selectedReason || "No reason available"}
          </pre>
        </div>

      </div>
    </div>
  </div>
)}
    </div>
  );
};

export default ViewFeeProtector;